module.exports = __webpack_public_path__ + "img/upload-file.7365fdfe.png";